var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 10,
    viewBox: "0 0 11 10",
    width: 11,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.10486
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.79028 5.00141 1.49998-1.49998s.75004-.75-.37499-1.87498c-1.12498-1.124981-1.87498-.37499-1.87498-.37499s-1.12498 1.12498-1.87497 1.87497-.74999 1.49998-.37499 1.87497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.29077 5.00469-1.49998 1.49999s-.74999.74999.375 1.87497c1.12498 1.12499 1.87497.375 1.87497.375s.93749-.93749 1.68748-1.68748.93749-1.68748.5625-2.06248"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link.f5ceba9377f43bbc374f9730d1600346.svg";